module.exports = __webpack_public_path__ + "static/media/star.8834a5f2.svg";